<template>
    <div class="page-content">
        <h3>Firma Corporativa</h3>
        <hr />

        <div v-if="isAdministrative" class="signature-section mb-4">
            <b-card>
                <template #header>
                    <h5 class="mb-0">
                        <i class="fa fa-signature"></i> Firma Corporativa
                    </h5>
                </template>

                <div v-if="currentSignature" class="mb-3">
                    <label class="form-label">Firma actual:</label>
                    <div class="signature-preview">
                        <img
                            :src="currentSignature"
                            alt="Firma corporativa"
                            style="max-width: 300px; max-height: 150px; border: 1px solid #ddd; padding: 10px; background: #fff;"
                        />
                    </div>
                </div>

                <b-form-group label="Subir nueva firma (PNG)">
                    <b-form-file
                        v-model="signatureFile"
                        accept="image/png"
                        :state="signatureFileState"
                        placeholder="Seleccione un archivo PNG..."
                        drop-placeholder="Arrastre el archivo aquí..."
                        @input="onSignatureFileSelected"
                    />
                    <small class="form-text text-muted">
                        Solo se permiten archivos PNG. Tamaño máximo: 2MB
                    </small>
                </b-form-group>

                <div class="mt-3">
                    <b-button
                        variant="primary"
                        @click="uploadSignature"
                        :disabled="!signatureFile || uploading"
                    >
                        <i class="fa fa-upload"></i>
                        {{ uploading ? 'Subiendo...' : 'Subir Firma' }}
                    </b-button>
                    <b-button
                        variant="secondary"
                        @click="clearSignatureFile"
                        :disabled="!signatureFile || uploading"
                        class="ml-2"
                    >
                        Cancelar
                    </b-button>
                </div>
            </b-card>
        </div>

        <div v-else>
            <p>No tiene permisos para administrar la firma corporativa.</p>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'account-signature-page',
    data() {
        return {
            signatureFile: null,
            uploading: false,
            currentSignature: null,
        };
    },
    computed: {
        isAdministrative() {
            return (
                this.user &&
                this.user.profile &&
                this.user.profile.slug === 'administrativo'
            );
        },
        signatureFileState() {
            if (!this.signatureFile) return null;
            if (this.signatureFile.type !== 'image/png') return false;
            if (this.signatureFile.size > 2 * 1024 * 1024) return false; // 2MB
            return true;
        },
    },
    created() {
        this.loadUserSignature();
    },
    methods: {
        loadUserSignature() {
            if (this.user && this.user.signature) {
                this.currentSignature = this.user.signature;
            }
        },
        onSignatureFileSelected(file) {
            if (file && file.type !== 'image/png') {
                toastr.error('Solo se permiten archivos PNG');
                this.signatureFile = null;
                return;
            }
            if (file && file.size > 2 * 1024 * 1024) {
                toastr.error('El archivo no puede ser mayor a 2MB');
                this.signatureFile = null;
                return;
            }
        },
        clearSignatureFile() {
            this.signatureFile = null;
        },
        uploadSignature() {
            if (!this.signatureFile) {
                toastr.error('Por favor seleccione un archivo');
                return;
            }

            if (this.signatureFile.type !== 'image/png') {
                toastr.error('Solo se permiten archivos PNG');
                return;
            }

            if (this.signatureFile.size > 2 * 1024 * 1024) {
                toastr.error('El archivo no puede ser mayor a 2MB');
                return;
            }

            this.uploading = true;

            const formData = new FormData();
            formData.append('signature', this.signatureFile);

            axios
                .post('/web/v1/users/upload-signature', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then((response) => {
                    if (response.data.status) {
                        toastr.success(
                            response.data.msg ||
                                'Firma corporativa actualizada exitosamente'
                        );
                        this.currentSignature = response.data.signature;
                        this.signatureFile = null;
                        if (this.$store && this.$store.state.user) {
                            this.$store.state.user.signature =
                                response.data.signature;
                        }
                    } else {
                        toastr.error(
                            response.data.msg || 'Error al subir la firma'
                        );
                    }
                })
                .catch((error) => {
                    console.error('Error al subir la firma:', error);
                    toastr.error(
                        error.response?.data?.msg || 'Error al subir la firma'
                    );
                })
                .finally(() => {
                    this.uploading = false;
                });
        },
    },
};
</script>

